import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';

const ProductAppBlocks = ({classes}) => {
  const container = useRef(null);

  useEffect(() => {
    const appBlocks = document.getElementById('product-app-blocks');
    container.current.appendChild(appBlocks);
  }, []);

  return <div className={classes} ref={container}></div>
}

export default ProductAppBlocks;